module.exports = __webpack_public_path__ + "img/about-product-1.9977b1a9.png";